import React from 'react';
import { Box, Table } from 'edenred-ui';
import { useTranslation } from 'react-i18next';

import { TableHeaderTooltip } from '@epi-pages/Reports/TableHeaderTooltip';

export const LoadRequestsTableHead = () => {
  const { t } = useTranslation();

  return (
    <Table.Row>
      <Table.Cell id="load-requests-request-date">
        {t('containers.deposit_money.load_requests_tab.request_date')}
      </Table.Cell>
      <Table.Cell id="load-requests-load-date">
        {t('containers.deposit_money.load_requests_tab.load_date')}
      </Table.Cell>
      <Table.Cell id="load-requests-employee">
        {t('containers.deposit_money.load_requests_tab.employee')}
      </Table.Cell>
      <Table.Cell id="load-requests-status">
        {t('containers.deposit_money.load_requests_tab.status')}
      </Table.Cell>
      <Table.Cell id="load-requests-requested-for">
        {t('containers.deposit_money.load_requests_tab.requested_for')}
      </Table.Cell>
      <Table.Cell id="load-requests-load-value" align="right">
        {t('containers.deposit_money.load_requests_tab.load_value')}
      </Table.Cell>
      <Table.Cell id="load-requests-total-load" align="right">
        {t('containers.deposit_money.load_requests_tab.total_load')}
      </Table.Cell>
      <Table.Cell id="load-requests-total-deduction" align="right">
        <Box
          display="flex"
          alignItems="center"
          justifyContent="flex-end"
          width="100%"
        >
          {t('containers.deposit_money.load_requests_tab.total_deduction')}
          <TableHeaderTooltip
            tooltipText={t(
              'containers.deposit_money.load_requests_tab.total_info'
            )}
          />
        </Box>
      </Table.Cell>
    </Table.Row>
  );
};
